import React, { useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "./Button";
import { downloadFile } from "../../utils/download";

// Botão "Exportar Excel" — baixa todos os registros da tela em .xlsx.
export default function ExportXlsxButton({
  url,
  filename,
  label = "Exportar Excel",
  className = "",
}) {
  const [loading, setLoading] = useState(false);
  const onClick = async () => {
    setLoading(true);
    try {
      await downloadFile(url, filename);
    } catch (e) {
      alert("Não foi possível exportar agora. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={loading}
      // Verde do Excel — destaque na tela.
      className={`gap-2 border-transparent bg-[#217346] text-white hover:bg-[#1b5e3a] ${className}`}
    >
      <FileSpreadsheet size={16} /> {loading ? "Gerando..." : label}
    </Button>
  );
}
